import { Button } from "react-bootstrap";
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
const ActiveFilter = ({ filters, onRemove, clearFilter }) => {
  return (
    <div className="apply-filter">
      {Object.values(filters).some((vals) => vals.length > 0) ? (
          <div className="filter-block">
            <div className="filter-block-left full">
              {Object.entries(filters).map(([key, values], index) =>
                values.length ? (
                  <div className="filter-div" key={index}>
                    <div className="filter-div-title">
                      <span>
                        {key.charAt(0).toUpperCase() + key.slice(1)} |
                      </span>
                    </div>
                    <div className="filter-div-list">
                      {values.map((val, i) => (
                        <div className="filter-result" id={val} rt={i} key={i}>
                          {val == "Webinar emails" ? "Events emails" : val == "Webinar registration" ? "Events registration" : val}
                          <img
                            src={path_image + "filter-close.svg"}
                            alt="Close-filter"
                            onClick={() => onRemove(key, val)}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null
              )}
            </div>
            <div className="clear-filter">
              <Button
                className="btn btn-outline-primary btn-bordered"
                onClick={clearFilter}
              >
                Remove All
              </Button>
            </div>
          </div>
      ) : null}
    </div>
  );
};

export default ActiveFilter
